import { parse } from '../../util/urlHelpers';
import { verify } from '../../ducks/emailVerification.duck';

// ================ Load data ================ //

// Only a link with a token (?t=…) verifies; a plain page view sends nothing (it used to POST
// verify_email with an empty token and show the resulting error).
export const loadData = (params, search) => {
  const urlParams = parse(search);
  const verificationToken = urlParams.t;
  return verificationToken ? verify(`${verificationToken}`) : () => Promise.resolve();
};
